import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AdminSidebar from "./AdminSidebar";
import { useAdminAuth } from "@/hooks/useAdminAuth";

export default function AdminLayout() {
  const auth = useAdminAuth();
  const nav = useNavigate();

  if (auth.loading) {
    return (
      <main className="min-h-screen flex items-center justify-center text-steel-300">
        <Loader2 className="w-4 h-4 animate-spin mr-2" /> Checking session…
      </main>
    );
  }

  if (!auth.user) return <Navigate to="/admin/login" replace />;
  if (!auth.isAdmin) {
    return (
      <main className="min-h-screen flex items-center justify-center p-6">
        <div className="card-dark max-w-md p-6 text-center">
          <h1 className="font-display text-xl text-white">Not authorized</h1>
          <p className="text-steel-300 mt-2">
            This account exists but isn't in the admin allow-list. Ask the project owner to add{" "}
            <span className="text-forge-300">{auth.user.email}</span> to <code>public.admin_users</code>.
          </p>
          <button onClick={() => auth.signOut()} className="btn-outline mt-4 w-full">Sign out</button>
        </div>
      </main>
    );
  }

  return (
    <div className="min-h-screen flex">
      <AdminSidebar
        userEmail={auth.user.email ?? null}
        onSignOut={async () => { await auth.signOut(); nav("/admin/login"); }}
      />
      <main className="flex-1 p-6 overflow-x-auto"><Outlet /></main>
    </div>
  );
}
